import { useVehicle } from '@motorway/motorway-handshake-components';
import type { Enquiry } from '@motorway/motorway-handshake-components/types';

import { formatCurrency } from '../../../helpers';

type EnquiryRecord = Enquiry['enquiry'];

interface MessagingListSection {
  heading: string;
  data: [string, string][];
}

type MessagingListFormatter = (enquiry: EnquiryRecord) => MessagingListSection;

const getSalePrices = (enquiry: EnquiryRecord) => {
  const { closingBid, vehicleDetails } = enquiry ?? {};
  const { financeFigure: vehicleFinanceFigure, isVehicleOnFinance } = vehicleDetails ?? {};

  const financeFigure: number = (isVehicleOnFinance && vehicleFinanceFigure) || 0;

  return { closingBid, financeFigure };
};

const calculatePriceDetails = (enquiry: EnquiryRecord): MessagingListSection => {
  const { closingBid, financeFigure } = getSalePrices(enquiry);

  const data: [string, string][] = [
    ['Sold for', formatCurrency(closingBid?.value)],
  ];

  if (financeFigure && financeFigure > 0) {
    data.push(['Outstanding finance', formatCurrency(financeFigure)]);
  }

  return {
    heading: 'Price details',
    data,
  };
};

const calculateFinalInvoice = (enquiry: EnquiryRecord): MessagingListSection => {
  const { closingBid, financeFigure } = getSalePrices(enquiry);

  const data: [string, string][] = [
    ['Total to pay', formatCurrency(closingBid?.value)],
  ];

  if (financeFigure && financeFigure > 0) {
    data.push(['To the seller', formatCurrency((closingBid?.value ?? 0) - financeFigure)]);
    data.push(['To the finance company', formatCurrency(financeFigure)]);
  }

  return {
    heading: '',
    data,
  };
};

export const MESSAGING_LIST_FORMATTERS = {
  PRICE_DETAILS: calculatePriceDetails,
  CALCULATE_FINAL_INVOICE: calculateFinalInvoice,
};

export const useMessagingListHelpers = (formatter: MessagingListFormatter) => {
  const { vehicle: { enquiry } } = useVehicle();

  return formatter(enquiry);
};
